import concat from 'lodash/concat'
import { createSelectors as createBaseButtonSelectors } from '../BaseButton/BaseButton'

export const selectors = concat(
  [
    {
      name: 'root',
      label: 'Wrapper',
      selector: '&'
    }
  ],

  createBaseButtonSelectors({
    name: 'buttonOne',
    label: 'Button One',
    selector: '& .buttonOne'
  }),

  createBaseButtonSelectors({
    name: 'buttonTwo',
    label: 'Button Two',
    selector: '& .buttonTwo'
  }),

  createBaseButtonSelectors({
    name: 'buttonThree',
    label: 'Button Three',
    selector: '& .buttonThree'
  })
)


export default selectors